export enum CarouselQueryKeys {
	GetCarousel = 'get.carousel',
}

export enum CarouselMutationKeys {
	DeleteCarouselItem = 'delete.carouselItem',
	UpdateCarouselItem = 'update.carouselItem',
	CreateCarouselItem = 'create.carouselItem',
}

export enum LoginAnnouncementQueryKeys {
	GetLoginAnnouncement = 'get.loginAnnouncement',
}

export enum LoginAnnouncementMutationKeys {
	CreateLoginAnnouncement = 'create.loginAnnouncement',
	UpdateLoginAnnouncement = 'update.loginAnnouncement',
	DeleteLoginAnnouncement = 'delete.loginAnnouncement',
	GetAnnouncementBannerUploadFileUrl = 'get.announcementBannerUploadFileUrl',
}

export enum GeneralSettingQueryKeys {
	GetGeneralSetting = 'get.generalSetting',
}

export enum GeneralSettingMutationKeys {
	UpdateGeneralSetting = 'update.generalSetting',
}

export enum GameTypeSettingQueryKeys {
	GetGameTypeSetting = 'get.gameTypeSetting',
}

export enum GameTypeSettingMutationKeys {
	UpdateGameTypeSetting = 'update.gameTypeSetting',
}

export enum DynamicSectionQueryKeys {
	GetDynamicSection = 'get.dynamicSection',
	GetDynamicSectionById = 'get.dynamicSectionById',
}

export enum DynamicSectionMutationKeys {
	CreateDynamicSection = 'create.dynamicSection',
	UpdateDynamicSection = 'update.dynamicSection',
	DeleteDynamicSection = 'delete.dynamicSection',
}

export enum DynamicPageQueryKeys {
	GetDynamicPage = 'get.dynamicPage',
	GetDynamicPageById = 'get.dynamicPageById',
}

export enum DynamicPageMutationKeys {
	CreateDynamicPage = 'create.dynamicPage',
	UpdateDynamicPage = 'update.dynamicPage',
	DeleteDynamicPage = 'delete.dynamicPage',
	AddSectionToPage = 'add.sectionToPage',
	UpdateDynamicPageOrder = 'update.dynamicPageOrder',
	RemoveSectionFromPage = 'remove.sectionFromPage',
}

export enum SlideAnnouncementQueryKeys {
	GetSlideAnnouncement = 'get.slideAnnouncement',
}

export enum SlideAnnouncementMutationKeys {
	CreateSlideAnnouncement = 'create.slideAnnouncement',
	UpdateSlideAnnouncement = 'update.slideAnnouncement',
}

export enum ProfilePageBannerQueryKeys {
	GetProfilePageBanners = 'get.profilePageBanners',
}

export enum ProfilePageBannerMutationKeys {
	CreateProfilePageBanner = 'create.profilePageBanner',
	UpdateProfilePageBanner = 'update.profilePageBanner',
	DeleteProfilePageBanner = 'delete.profilePageBanner',
}

export enum BrokeNotificationQueryKeys {
	GetBrokeNotifications = 'get.brokeNotifications',
	GetBrokeNotificationById = 'get.brokeNotificationById',
}

export enum BrokeNotificationMutationKeys {
	CreateBrokeNotification = 'create.brokeNotification',
	UpdateBrokeNotification = 'update.brokeNotification',
	DeleteBrokeNotification = 'delete.brokeNotification',
}

export enum MainWalletSettingQueryKeys {
	GetMainWalletSetting = 'get.mainWalletSetting',
}

export enum MainWalletSettingMutationKeys {
	UpdateMainWalletSetting = 'update.mainWalletSetting',
}

export enum DynamicPagePresetQueryKeys {
	GetDynamicPagePresets = 'get.dynamicPagePresets',
}

export enum DynamicPagePresetMutationKeys {
	DuplicateDynamicPagePreset = 'duplicate.dynamicPagePreset',
}

export enum ThemePresetQueryKeys {
	GetThemePresets = 'get.themePresets',
}

export enum ThemePresetMutationKeys {
	ApplyThemePreset = 'apply.themePreset',
}
